import { styled } from "@mui/material";
import Typography from "components/Typography";
import type { TypographyProps } from "components/Typography";
import { useDialogContext } from "./Dialog";

const titleVariant = {
  sm: "TextS",
  md: "TextL",
  lg: "TextXXL",
  full: "TextXXL",
} as const;

/**
 * DialogTitle component that adapts its typography variant based on the dialog size.
 * It is displayed at the top of the dialog.
 */
const DialogTitle = styled((props: TypographyProps) => {
  const dialogContext = useDialogContext();
  const variant = titleVariant[dialogContext.size];

  return <Typography id={dialogContext.ariaLabelledby} component="h2" variant={variant} {...props} />;
})(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.contrastText,
}));

export default DialogTitle;
